import { isAxiosError } from 'axios'
import { isEmpty } from 'lodash'
import moment from 'moment'

import constants from 'core/data-model/constants/messages'
import { d } from 'core/service/lib/decimal'

const birthdate = {
  isEquals: (birthdate1, birthdate2) => {
    const b1 = birthdate.toApi(birthdate1)
    const b2 = birthdate.toApi(birthdate2)
    return b1 === b2
  },
  toFrontEnd: (birthdate) => {
    const sections = birthdate.split('-')
    const current = moment()
    if (parseInt(sections[0]) > current.year()) {
      return `${sections[2]}/${sections[1]}/${parseInt(sections[0])}`
    } else {
      return `${sections[2]}/${sections[1]}/${parseInt(sections[0]) + 543}`
    }
  },
  toApi: (birthdate) => {
    if (/\d{4}-\d{2}-\d{2}/.test(birthdate)) return birthdate
    if (/\d{2}\/\d{2}\/\d{4}/.test(birthdate)) {
      const sections = birthdate.split('/')
      const current = moment()
      if (parseInt(sections[2]) > current.year()) {
        return `${parseInt(sections[2]) - 543}-${sections[1]}-${sections[0]}`
      } else {
        return `${sections[2]}-${sections[1]}-${sections[0]}`
      }
    }
    return birthdate
  },
}

const modalFactor = {
  toSymbol: (modelFactorID) => {
    switch (modelFactorID) {
      case 'model-factor_1':
        return 'A'
      case 'model-factor_2':
        return 'S'
      case 'model-factor_3':
        return 'M'
      case 'model-factor_4':
        return 'Q'
      case 'model-factor_5':
        return 'I'
      case 'model-factor_6':
        return 'O'
    }
  },
  toModalFactorId: (symbol) => {
    switch (symbol) {
      case 'A':
      case 'รายปี':
        return 'model-factor_1'
      case 'S':
      case 'รายหกเดือน':
        return 'model-factor_2'
      case 'M':
      case 'รายเดือน':
        return 'model-factor_3'
      case 'Q':
      case 'รายสามเดือน':
        return 'model-factor_4'
      case 'I':
      case 'ชำระครั้งเดียว':
        return 'model-factor_5'
      case 'O':
        return 'model-factor_6'
      default:
        return undefined
    }
  },
  toLabel: (modelFactor) => {
    switch (modelFactor) {
      case 'model-factor_1':
      case 'A':
        return 'รายปี'
      case 'model-factor_2':
      case 'S':
        return 'รายหกเดือน'
      case 'model-factor_3':
      case 'M':
        return 'รายเดือน'
      case 'model-factor_4':
      case 'Q':
        return 'รายสามเดือน'
      case 'model-factor_5':
      case 'I':
        return 'ชำระครั้งเดียว'
      default:
        return ''
    }
  },
}

function defaultIfEmpty(value, defaultValue) {
  if (isEmpty(value)) return defaultValue
  return value
}

/**
 * defaultBirthdate
 * @param value {number} as age
 * @param unit {'year'}
 * @returns {string}
 */
function defaultBirthdate({ value, unit }) {
  const now = moment()
  return now.add(-value, unit).format('YYYY-MM-DD')
}

/**
 * toNumber
 * @param text {string}
 * @returns {number}
 */
function toNumber(text) {
  if (isEmpty(text) || text === '-') return 0
  return d(text.replaceAll(',', '')).toNumber()
}

function tryToNumber(text) {
  try {
    return toNumber(text)
  } catch (e) {
    return 0
  }
}

function getMessageError(error) {
  let notificationType = 'GenericError'
  let message = ''
  if (isAxiosError(error)) {
    if (error.response && error.response.data && error.response.data.message) {
      message = error.response.data.message
    } else {
      message = 'Request failed'
    }
  }

  if (message.length === 0 && error.message) {
    message = error.message
  }

  if (message === 'lbCode terminated') {
    notificationType = 'INACTIVE_USER'
    message = constants.INACTIVE_USER_ERROR_MSG
  }

  return { type: notificationType, message }
}

export const partnerApiUtils = {
  birthdate,
  modalFactor,
  defaultIfEmpty,
  defaultBirthdate,
  toNumber,
  tryToNumber,
  getMessageError,
}
